import React from "react";

// core components
import Navbar from "../components/Navbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import SupportedBy from "components/SupportedBy.js";
import DemoFooter from "../components/Footer.js";
import TextGrid from "../components/TextGrid.js";
import Photos from "../components/Photos.js";

import AboutPoints from "../components/AboutPoints.js";

import Speaker from "../components/SpeakerCard";
import SponsorNew from "../components/SponsorNew";


import Editions from "components/Editions.js";

function Home() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <Navbar />
      <LandingPageHeader />
      <SupportedBy />
      <section id="about">
        <TextGrid />
      </section>
      <div
        style={{
          background: "#000",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="section section-with-space"
        data-parallax={true}
      >
       
        <AboutPoints />
        <section id="speakers" />
        <Speaker />

        <section id="partners" />
        <SponsorNew />

        <Photos />

        <Editions />
      </div>

      <DemoFooter />
    </>
  );
}

export default Home;
